import React, { useState } from 'react';

import { connect } from 'react-redux';
import * as projectActions from '../actions/project';

const initialFieldValues = {
  name: '',
};

const ProjectFrom = (props) => {
  const [values, setValues] = useState(initialFieldValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!values.name) return;

    const onSuccess = () => {
      resetForm();
    };

    props.createProject(values, onSuccess);
  };

  return (
    <div className="box">
      <form onSubmit={handleSubmit} className="is-flex">
        <div className="field" style={{ width: '200px' }}>
          <div>
            <label
              className="is-block is-size-7 is-uppercase has-text-weight-bold mb-1"
              htmlFor="name"
            >
              Add new project
            </label>
          </div>

          <div className="field-body">
            <div className="field">
              <p className="control">
                <input
                  className="input"
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Project name"
                  value={values.name}
                  onChange={handleInputChange}
                />
              </p>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="button is-primary has-margin-top-auto mb-3 ml-2"
        >
          Add
        </button>
      </form>
    </div>
  );
};

const mapActionToProps = {
  createProject: projectActions.createProject,
};

export default connect(null, mapActionToProps)(ProjectFrom);
